// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.z-10 {
  z-index: 10;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.h-20 {
  height: 5rem;
}
.h-5 {
  height: 1.25rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.gap-2 {
  gap: 0.5rem;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-transparent {
  border-color: transparent;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-zinc-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.object-contain {
  object-fit: contain;
}
.p-6 {
  padding: 1.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pt-28 {
  padding-top: 7rem;
}
.text-center {
  text-align: center;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
.text-8xl {
  font-size: 6rem;
  line-height: 1;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-bold {
  font-weight: 700;
}
.leading-none {
  line-height: 1;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-gray-900\\/5 {
  --tw-ring-color: rgb(17 24 39 / 0.05);
}

@theme {
  --breakpoint-*: initial;
  --breakpoint-tablet: 40rem;      /* 640px */
  --breakpoint-laptop: 64rem;      /* 1024px */
  --breakpoint-desktop: 80rem;     /* 1280px */
}

.rubik-trade {
  font-family: 'Inter', sans-serif;
  font-optical-sizing: auto;
  font-weight: bold;
  font-style: normal;
}
.header{
    position:fixed;
    top: 150;
    width: 100%;
    height: 100px;
    z-index:6;
    background-image: linear-gradient(to right ,#f51fa6, rgba(244, 244, 13, 0.966));
}

body{
  zoom: 0.2;
  margin:0;

  min-height: -webkit-fill-available;
}
.my-text{
  font-size:10px;
  color : red;    
  }
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(350px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.fade-in-right {
  animation: fadeInRight 0.6s ease-out forwards;
}

@media only screen and (max-width: 500px) {
  body{
    zoom: 0.4;
    margin:0;
    min-height: -webkit-fill-available;
  }
  .my-text{
    font-size:12px;
    color : red;    
    }
}
@media only screen and (min-width: 501px) {
  body{
    zoom: 0.5;
    margin:0;
    min-height: -webkit-fill-available;
  }
  .my-text{
    font-size:18px;
    color : red;    
    }
}
@media only screen and (min-width: 800px) {
  body{
    zoom: 0.6;
    margin:0;
    min-height: -webkit-fill-available;
  }
  .my-text{
    font-size:20px;
    color : red;    
    }
}
@media only screen and (min-width: 1200px) {
  body{
    zoom: 1.0;
    margin:0;
    min-height: -webkit-fill-available;
  }
  .my-text{
    font-size:23px;
    color : red;    
    }
}

@media (any-pointer: coarse) {
  /* do your own styles */
  /* .flex-container-mobile{
    
    flex-direction: column !important; 
  } */

  .flex-container-project-mobile{
    flex-direction: column !important; 
  }
  .noHeight{
    min-height: 40px !important;
  }
  .project-card-mobile{
    display: inline !important;
    flex-direction: column !important; 
    justify-content: start !important;
    column-gap: 10px;
    width:100%;
    position: 'relative' !important
  }
  .project-card-component{
      width:100% !important;
      height:23% !important;
      font-size:35px !important;
  }

  .searchBar{
    width:300px !important
  }
  .buttonTool{
    width:120px !important;
    height:50px !important;
    font-size: 10px !important;
  }
  html{
    font-size:9px !important;
  }
  .my-text{
      width:300px !important;
      height: 100px !important;
      color : white !important;    
  }

  .my-center-text{
    width: 800px !important;
    height: 500px !important;
    font-size:13px  !important;
     
}
.mobile-font{
  font-size: 15px !important;
 
 }


 .project-font{
  font-size: 9px !important;
 
 }

 .mobile-hero-container{
  border-radius: 25px !important;
 }
 .mobile-hero{
  width: 100% !important;
  height: 400px !important;
  border-radius: 25px !important;
 }
 img{
  border-radius: 25px !important;
 }
 
 .audience-font{
  font-size: 30px !important;
 }

 .project-card{
  /* width: 380px !important; */
  height: 50% !important;
 }

 .mobile-footer{
  height: 750px !important;
 }
 .pic-rotate{
  font-size: 10px !important;
 }
 .pic-resize{
  height: 150px !important;
 }

 @supports not (-webkit-touch-callout: none) {
  /* CSS specific to non -iOS devices */ 
  html{
    font-size:24px !important;
  }
  .buttonTool{
    width:120px !important;
    height:80px !important;
    font-size: 20px !important;
  }
  .project-card-component{
      width:100% !important;
      height:28% !important;
      font-size:45px !important;
  }  
  .pic-rotate{
    font-size: 20px !important;
   }
   .mobile-font{
    font-size: 30px !important;
   
   }
   .audience-font{
    font-size: 60px !important;
   }
   .project-font{
    font-size: 24px !important;
   
   }
}

}
.pic-resize{
  height: 100px !important;
 }

.appear{
  width: 400px;
  height: 400px;
}

.background_gradient {
  background-color: black; /* For browsers that do not support gradients */
  background-image: linear-gradient(to bottom right, black, rgb(29, 29, 28));
}
.background_gradient_project{
  background-color: black; /* For browsers that do not support gradients */
  background-image: linear-gradient(to bottom right, rgb(29, 28, 28), rgb(12, 12, 1));
}
.button {
  background-color: blue; /* Original background color */
  color: white; /* Text color */
  padding: 10px 20px; /* Padding */
  border: none; /* No border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
}

.button:hover {
  background-color: green; /* Background color changes on hover */
}

.flex-container {
  display: flex;
  align-items: center;
}
 .backgroundFooter{
  height: 200px;
  background-color: black; /* For browsers that do not support gradients */
  background-image: linear-gradient(to right, blue , grey);
 }
#filldiv:hover {
  /* background-color: yellow;
  transition: background-color 2s ease;  */
  max-width: 150px;
  max-height: 1000px;
  border-radius: 4px;
}
#outerdiv:hover {
  background-color: blue;
  font-size: 18px;

}

.scrollable {
  background-color: rgb(235, 241, 244);
  color: white;
  width: 300px;
  height: 150px;
  margin: 20px;
  padding: 10px;
  overflow-y: scroll; /* Vertical scroll */
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}


.card {
  background-color: rgb(235, 241, 244);
  color: white;
  margin: 20px;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}


.container {
  position: absolute;
  width: 300px;
  height: 200px;
  overflow: hidden;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
img{
  transform: rotate(0deg);
}
.overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.testCard:hover .overlay {
  opacity: 0.5;
}

.popup {
  background: white;
  color: black;
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
}

.rotate-on-hover {
  transition: transform 0.4s ease;
}
.rotate-on-hover:hover {
  transform: rotate(30deg); /* You can change this value */
}


.trade-body{
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  display: flex;
  place-items: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow: hidden;
  margin: 0;
  padding: 20px;
  overflow: -moz-scrollbars-vertical;
  overflow-y: scroll;
}

.hover-text {
            color: #FFFF !important;/* Initial text color */
            transition: color 0.5s ease; /* Smooth transition */
}

.hover-text:hover {
    color: #ff5733 !important; /* Color to change on hover */
}

.hover-text-hero {
            color: #000 !important;/* Initial text color */
            transition: color 0.5s ease !important; /* Smooth transition */
}

.hover-text-hero:hover {
    color: #ff5733!important; /* Color to change on hover */
}

.rotate-icon {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* The sidebar menu */
.sidenav {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1; /* Stay on top */
  top: 0;
  left: 0;
  background-color: #111; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidebar */
}

/* The sidebar links */
.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

/* When you mouse over the navigation links, change their color */
.sidenav a:hover {
  color: #f1f1f1;
}



/* Position and style the close button (top right corner) */
.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 12px;
  font-size: 36px;
  margin-left: 50px;
}

/* The button used to open the sidebar */
.openbtn {
  font-size: 20px;
  cursor: pointer;
  background-color: #111;
  color: white;
  padding: 10px 15px;
  border: none;
}

.openbtn:hover {
  background-color: #444;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left .5s; /* If you want a transition effect */
  padding: 20px;
}


/* The sidebar menu */
.sidebar {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1; /* Stay on top */
  top: 0;
  left: 0;
  background-color: #111; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidebar */
}

/* The sidebar links */
.sidebar a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

/* When you mouse over the navigation links, change their color */
.sidebar a:hover {
  color: #f1f1f1;
}

/* Position and style the close button (top right corner) */
.sidebar .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 12px;
  margin-left: 50px;
}

/* The button used to open the sidebar */
.openbtn {
  font-size: 20px;
  cursor: pointer;
  background-color: #111;
  color: white;
  padding: 10px 15px;
  border: none;
}

.openbtn:hover {
  background-color: #444;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left .5s; /* If you want a transition effect */
  padding: 20px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidebar {padding-top: 15px;}
  .sidebar a {font-size: 18px;}
}

/* .centerAlignContents {
  display: flex;
  justify-content: center;
  align-items: center;
} */

#root , html ,body{
  height:100%;
}
.center-loading-icon {
    /* Position the top-left corner at the center of the container/viewport */
    position: absolute; /* or fixed, depending on the desired behavior relative to scrolling */
    top: 50%;
    left: 50%;
    
    /* Shift the element back by half of its own dimensions */
    transform: translate(-50%, -50%);
    
}


.center-icon{
      display: flex;
    justify-content: center; /* Centers horizontally */
    align-items: center; /* Centers vertically */
    height: 100vh; /* Ensures the container fills the full viewport height */
}


.hover\\:bg-blue-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}


.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}


@media not all and (min-width: 640px) {

  .max-sm\\:flex-1 {
    flex: 1 1;
  }

  .max-sm\\:p-4 {
    padding: 1rem;
  }

  .max-sm\\:text-\\[72px\\] {
    font-size: 72px;
  }

  .max-sm\\:leading-\\[82px\\] {
    line-height: 82px;
  }
}


@media (min-width: 640px) {

  .sm\\:h-40 {
    height: 10rem;
  }

  .sm\\:w-40 {
    width: 10rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }
}


@media (min-width: 1280px) {

  .xl\\:whitespace-nowrap {
    white-space: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,uBAAuB;EACvB,0BAA0B,OAAO,UAAU;EAC3C,0BAA0B,OAAO,WAAW;EAC5C,2BAA2B,MAAM,WAAW;AAC9C;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;IACI,cAAc;IACd,QAAQ;IACR,WAAW;IACX,aAAa;IACb,SAAS;IACT,+EAA+E;AACnF;;AAEA;EACE,SAAS;EACT,QAAQ;;EAER,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,WAAW;EACX;AACF;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,SAAS;IACT,QAAQ;IACR,kCAAkC;EACpC;EACA;IACE,cAAc;IACd,WAAW;IACX;AACJ;AACA;EACE;IACE,SAAS;IACT,QAAQ;IACR,kCAAkC;EACpC;EACA;IACE,cAAc;IACd,WAAW;IACX;AACJ;AACA;EACE;IACE,SAAS;IACT,QAAQ;IACR,kCAAkC;EACpC;EACA;IACE,cAAc;IACd,WAAW;IACX;AACJ;AACA;EACE;IACE,SAAS;IACT,QAAQ;IACR,kCAAkC;EACpC;EACA;IACE,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;EACE,uBAAuB;EACvB;;;KAGG;;EAEH;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,iCAAiC;IACjC,iCAAiC;IACjC,gBAAgB;IAChB,UAAU;IACV;EACF;EACA;MACI,qBAAqB;MACrB,qBAAqB;MACrB,yBAAyB;EAC7B;;EAEA;IACE;EACF;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;MACI,sBAAsB;MACtB,wBAAwB;MACxB,wBAAwB;EAC5B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;;AAE9B;AACA;EACE,0BAA0B;;CAE3B;;;CAGA;EACC,yBAAyB;;CAE1B;;CAEA;EACC,8BAA8B;CAC/B;CACA;EACC,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;CAC/B;CACA;EACC,8BAA8B;CAC/B;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,6BAA6B;EAC7B,sBAAsB;CACvB;;CAEA;EACC,wBAAwB;CACzB;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,wBAAwB;CACzB;;CAEA;EACC,qCAAqC;EACrC;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;EAC5B;EACA;MACI,qBAAqB;MACrB,qBAAqB;MACrB,yBAAyB;EAC7B;EACA;IACE,0BAA0B;GAC3B;GACA;IACC,0BAA0B;;GAE3B;GACA;IACC,0BAA0B;GAC3B;GACA;IACC,0BAA0B;;GAE3B;AACH;;AAEA;AACA;EACE,wBAAwB;CACzB;;AAED;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB,EAAE,+CAA+C;EACxE,0EAA0E;AAC5E;AACA;EACE,uBAAuB,EAAE,+CAA+C;EACxE,mFAAmF;AACrF;AACA;EACE,sBAAsB,EAAE,8BAA8B;EACtD,YAAY,EAAE,eAAe;EAC7B,kBAAkB,EAAE,YAAY;EAChC,YAAY,EAAE,cAAc;EAC5B,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,4BAA4B;AAC/C;;AAEA;EACE,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;CACC;EACC,aAAa;EACb,uBAAuB,EAAE,+CAA+C;EACxE,wDAAwD;CACzD;AACD;EACE;0CACwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,eAAe;;AAEjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAE,oBAAoB;EACxC,kBAAkB;EAClB,4EAA4E;AAC9E;;;AAGA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,4EAA4E;AAC9E;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAIhB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AAPnB;AASA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,oCAAoC;EACpC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB,EAAE,8BAA8B;AAC1D;;;AAGA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EAEb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;YACY,uBAAuB,CAAC,uBAAuB;YAC/C,2BAA2B,EAAE,sBAAsB;AAC/D;;AAEA;IACI,yBAAyB,EAAE,6BAA6B;AAC5D;;AAEA;YACY,sBAAsB,CAAC,uBAAuB;YAC9C,sCAAsC,EAAE,sBAAsB;AAC1E;;AAEA;IACI,wBAAwB,EAAE,6BAA6B;AAC3D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qBAAqB;AACrB;EACE,YAAY,EAAE,qBAAqB;EACnC,QAAQ,EAAE,0CAA0C;EACpD,eAAe,EAAE,kBAAkB;EACnC,UAAU,EAAE,gBAAgB;EAC5B,MAAM;EACN,OAAO;EACP,sBAAsB,EAAE,SAAS;EACjC,kBAAkB,EAAE,8BAA8B;EAClD,iBAAiB,EAAE,oCAAoC;EACvD,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,cAAc;AAChB;;;;AAIA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sHAAsH;AACtH;EACE,2BAA2B,EAAE,oCAAoC;EACjE,aAAa;AACf;;;AAGA,qBAAqB;AACrB;EACE,YAAY,EAAE,qBAAqB;EACnC,QAAQ,EAAE,0CAA0C;EACpD,eAAe,EAAE,kBAAkB;EACnC,UAAU,EAAE,gBAAgB;EAC5B,MAAM;EACN,OAAO;EACP,sBAAsB,EAAE,SAAS;EACjC,kBAAkB,EAAE,8BAA8B;EAClD,iBAAiB,EAAE,oCAAoC;EACvD,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sHAAsH;AACtH;EACE,2BAA2B,EAAE,oCAAoC;EACjE,aAAa;AACf;;AAEA,gIAAgI;AAChI;EACE,UAAU,iBAAiB,CAAC;EAC5B,YAAY,eAAe,CAAC;AAC9B;;AAEA;;;;GAIG;;AAEH;EACE,WAAW;AACb;AACA;IACI,yEAAyE;IACzE,kBAAkB,EAAE,sEAAsE;IAC1F,QAAQ;IACR,SAAS;;IAET,yDAAyD;IACzD,gCAAgC;;AAEpC;;;AAGA;MACM,aAAa;IACf,uBAAuB,EAAE,yBAAyB;IAClD,mBAAmB,EAAE,uBAAuB;IAC5C,aAAa,EAAE,yDAAyD;AAC5E;;;AA/hBA;EAAA,kBA+hBC;EA/hBD;AA+hBC;;;AA/hBD;EAAA,kBA+hBC;EA/hBD;AA+hBC;;;AA/hBD;;EAAA;IAAA;EA+hBC;;EA/hBD;IAAA;EA+hBC;;EA/hBD;IAAA;EA+hBC;;EA/hBD;IAAA;EA+hBC;AAAA;;;AA/hBD;;EAAA;IAAA;EA+hBC;;EA/hBD;IAAA;EA+hBC;;EA/hBD;IAAA;EA+hBC;AAAA;;;AA/hBD;;EAAA;IAAA;EA+hBC;AAAA","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n@theme {\r\n  --breakpoint-*: initial;\r\n  --breakpoint-tablet: 40rem;      /* 640px */\r\n  --breakpoint-laptop: 64rem;      /* 1024px */\r\n  --breakpoint-desktop: 80rem;     /* 1280px */\r\n}\r\n\r\n.rubik-trade {\r\n  font-family: 'Inter', sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: bold;\r\n  font-style: normal;\r\n}\r\n.header{\r\n    position:fixed;\r\n    top: 150;\r\n    width: 100%;\r\n    height: 100px;\r\n    z-index:6;\r\n    background-image: linear-gradient(to right ,#f51fa6, rgba(244, 244, 13, 0.966));\r\n}\r\n\r\nbody{\r\n  zoom: 0.2;\r\n  margin:0;\r\n\r\n  min-height: -webkit-fill-available;\r\n}\r\n.my-text{\r\n  font-size:10px;\r\n  color : red;    \r\n  }\r\n@keyframes fadeInRight {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(350px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.fade-in-right {\r\n  animation: fadeInRight 0.6s ease-out forwards;\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n  body{\r\n    zoom: 0.4;\r\n    margin:0;\r\n    min-height: -webkit-fill-available;\r\n  }\r\n  .my-text{\r\n    font-size:12px;\r\n    color : red;    \r\n    }\r\n}\r\n@media only screen and (min-width: 501px) {\r\n  body{\r\n    zoom: 0.5;\r\n    margin:0;\r\n    min-height: -webkit-fill-available;\r\n  }\r\n  .my-text{\r\n    font-size:18px;\r\n    color : red;    \r\n    }\r\n}\r\n@media only screen and (min-width: 800px) {\r\n  body{\r\n    zoom: 0.6;\r\n    margin:0;\r\n    min-height: -webkit-fill-available;\r\n  }\r\n  .my-text{\r\n    font-size:20px;\r\n    color : red;    \r\n    }\r\n}\r\n@media only screen and (min-width: 1200px) {\r\n  body{\r\n    zoom: 1.0;\r\n    margin:0;\r\n    min-height: -webkit-fill-available;\r\n  }\r\n  .my-text{\r\n    font-size:23px;\r\n    color : red;    \r\n    }\r\n}\r\n\r\n@media (any-pointer: coarse) {\r\n  /* do your own styles */\r\n  /* .flex-container-mobile{\r\n    \r\n    flex-direction: column !important; \r\n  } */\r\n\r\n  .flex-container-project-mobile{\r\n    flex-direction: column !important; \r\n  }\r\n  .noHeight{\r\n    min-height: 40px !important;\r\n  }\r\n  .project-card-mobile{\r\n    display: inline !important;\r\n    flex-direction: column !important; \r\n    justify-content: start !important;\r\n    column-gap: 10px;\r\n    width:100%;\r\n    position: 'relative' !important\r\n  }\r\n  .project-card-component{\r\n      width:100% !important;\r\n      height:23% !important;\r\n      font-size:35px !important;\r\n  }\r\n\r\n  .searchBar{\r\n    width:300px !important\r\n  }\r\n  .buttonTool{\r\n    width:120px !important;\r\n    height:50px !important;\r\n    font-size: 10px !important;\r\n  }\r\n  html{\r\n    font-size:9px !important;\r\n  }\r\n  .my-text{\r\n      width:300px !important;\r\n      height: 100px !important;\r\n      color : white !important;    \r\n  }\r\n\r\n  .my-center-text{\r\n    width: 800px !important;\r\n    height: 500px !important;\r\n    font-size:13px  !important;\r\n     \r\n}\r\n.mobile-font{\r\n  font-size: 15px !important;\r\n \r\n }\r\n\r\n\r\n .project-font{\r\n  font-size: 9px !important;\r\n \r\n }\r\n\r\n .mobile-hero-container{\r\n  border-radius: 25px !important;\r\n }\r\n .mobile-hero{\r\n  width: 100% !important;\r\n  height: 400px !important;\r\n  border-radius: 25px !important;\r\n }\r\n img{\r\n  border-radius: 25px !important;\r\n }\r\n \r\n .audience-font{\r\n  font-size: 30px !important;\r\n }\r\n\r\n .project-card{\r\n  /* width: 380px !important; */\r\n  height: 50% !important;\r\n }\r\n\r\n .mobile-footer{\r\n  height: 750px !important;\r\n }\r\n .pic-rotate{\r\n  font-size: 10px !important;\r\n }\r\n .pic-resize{\r\n  height: 150px !important;\r\n }\r\n\r\n @supports not (-webkit-touch-callout: none) {\r\n  /* CSS specific to non -iOS devices */ \r\n  html{\r\n    font-size:24px !important;\r\n  }\r\n  .buttonTool{\r\n    width:120px !important;\r\n    height:80px !important;\r\n    font-size: 20px !important;\r\n  }\r\n  .project-card-component{\r\n      width:100% !important;\r\n      height:28% !important;\r\n      font-size:45px !important;\r\n  }  \r\n  .pic-rotate{\r\n    font-size: 20px !important;\r\n   }\r\n   .mobile-font{\r\n    font-size: 30px !important;\r\n   \r\n   }\r\n   .audience-font{\r\n    font-size: 60px !important;\r\n   }\r\n   .project-font{\r\n    font-size: 24px !important;\r\n   \r\n   }\r\n}\r\n\r\n}\r\n.pic-resize{\r\n  height: 100px !important;\r\n }\r\n\r\n.appear{\r\n  width: 400px;\r\n  height: 400px;\r\n}\r\n\r\n.background_gradient {\r\n  background-color: black; /* For browsers that do not support gradients */\r\n  background-image: linear-gradient(to bottom right, black, rgb(29, 29, 28));\r\n}\r\n.background_gradient_project{\r\n  background-color: black; /* For browsers that do not support gradients */\r\n  background-image: linear-gradient(to bottom right, rgb(29, 28, 28), rgb(12, 12, 1));\r\n}\r\n.button {\r\n  background-color: blue; /* Original background color */\r\n  color: white; /* Text color */\r\n  padding: 10px 20px; /* Padding */\r\n  border: none; /* No border */\r\n  border-radius: 5px; /* Rounded corners */\r\n  cursor: pointer; /* Pointer cursor on hover */\r\n}\r\n\r\n.button:hover {\r\n  background-color: green; /* Background color changes on hover */\r\n}\r\n\r\n.flex-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n .backgroundFooter{\r\n  height: 200px;\r\n  background-color: black; /* For browsers that do not support gradients */\r\n  background-image: linear-gradient(to right, blue , grey);\r\n }\r\n#filldiv:hover {\r\n  /* background-color: yellow;\r\n  transition: background-color 2s ease;  */\r\n  max-width: 150px;\r\n  max-height: 1000px;\r\n  border-radius: 4px;\r\n}\r\n#outerdiv:hover {\r\n  background-color: blue;\r\n  font-size: 18px;\r\n\r\n}\r\n\r\n.scrollable {\r\n  background-color: rgb(235, 241, 244);\r\n  color: white;\r\n  width: 300px;\r\n  height: 150px;\r\n  margin: 20px;\r\n  padding: 10px;\r\n  overflow-y: scroll; /* Vertical scroll */\r\n  border-radius: 5px;\r\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n\r\n\r\n.card {\r\n  background-color: rgb(235, 241, 244);\r\n  color: white;\r\n  margin: 20px;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n\r\n\r\n.container {\r\n  position: absolute;\r\n  width: 300px;\r\n  height: 200px;\r\n  overflow: hidden;\r\n}\r\n\r\n.container {\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\nimg{\r\n  transform: rotate(0deg);\r\n}\r\n.overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n  opacity: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.testCard:hover .overlay {\r\n  opacity: 0.5;\r\n}\r\n\r\n.popup {\r\n  background: white;\r\n  color: black;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n}\r\n\r\n.rotate-on-hover {\r\n  transition: transform 0.4s ease;\r\n}\r\n.rotate-on-hover:hover {\r\n  transform: rotate(30deg); /* You can change this value */\r\n}\r\n\r\n\r\n.trade-body{\r\n  font-family: \"Montserrat\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-style: normal;\r\n  display: flex;\r\n  margin: 0;\r\n  place-items: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  margin: 0;\r\n  padding: 20px;\r\n  overflow: -moz-scrollbars-vertical;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.hover-text {\r\n            color: #FFFF !important;/* Initial text color */\r\n            transition: color 0.5s ease; /* Smooth transition */\r\n}\r\n\r\n.hover-text:hover {\r\n    color: #ff5733 !important; /* Color to change on hover */\r\n}\r\n\r\n.hover-text-hero {\r\n            color: #000 !important;/* Initial text color */\r\n            transition: color 0.5s ease !important; /* Smooth transition */\r\n}\r\n\r\n.hover-text-hero:hover {\r\n    color: #ff5733!important; /* Color to change on hover */\r\n}\r\n\r\n.rotate-icon {\r\n  animation: rotate 1s linear infinite;\r\n}\r\n\r\n@keyframes rotate {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* The sidebar menu */\r\n.sidenav {\r\n  height: 100%; /* 100% Full-height */\r\n  width: 0; /* 0 width - change this with JavaScript */\r\n  position: fixed; /* Stay in place */\r\n  z-index: 1; /* Stay on top */\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #111; /* Black*/\r\n  overflow-x: hidden; /* Disable horizontal scroll */\r\n  padding-top: 60px; /* Place content 60px from the top */\r\n  transition: 0.5s; /* 0.5 second transition effect to slide in the sidebar */\r\n}\r\n\r\n/* The sidebar links */\r\n.sidenav a {\r\n  padding: 8px 8px 8px 32px;\r\n  text-decoration: none;\r\n  font-size: 25px;\r\n  color: #818181;\r\n  display: block;\r\n  transition: 0.3s;\r\n}\r\n\r\n/* When you mouse over the navigation links, change their color */\r\n.sidenav a:hover {\r\n  color: #f1f1f1;\r\n}\r\n\r\n\r\n\r\n/* Position and style the close button (top right corner) */\r\n.sidenav .closebtn {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 12px;\r\n  font-size: 36px;\r\n  margin-left: 50px;\r\n}\r\n\r\n/* The button used to open the sidebar */\r\n.openbtn {\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  background-color: #111;\r\n  color: white;\r\n  padding: 10px 15px;\r\n  border: none;\r\n}\r\n\r\n.openbtn:hover {\r\n  background-color: #444;\r\n}\r\n\r\n/* Style page content - use this if you want to push the page content to the right when you open the side navigation */\r\n#main {\r\n  transition: margin-left .5s; /* If you want a transition effect */\r\n  padding: 20px;\r\n}\r\n\r\n\r\n/* The sidebar menu */\r\n.sidebar {\r\n  height: 100%; /* 100% Full-height */\r\n  width: 0; /* 0 width - change this with JavaScript */\r\n  position: fixed; /* Stay in place */\r\n  z-index: 1; /* Stay on top */\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #111; /* Black*/\r\n  overflow-x: hidden; /* Disable horizontal scroll */\r\n  padding-top: 60px; /* Place content 60px from the top */\r\n  transition: 0.5s; /* 0.5 second transition effect to slide in the sidebar */\r\n}\r\n\r\n/* The sidebar links */\r\n.sidebar a {\r\n  padding: 8px 8px 8px 32px;\r\n  text-decoration: none;\r\n  font-size: 25px;\r\n  color: #818181;\r\n  display: block;\r\n  transition: 0.3s;\r\n}\r\n\r\n/* When you mouse over the navigation links, change their color */\r\n.sidebar a:hover {\r\n  color: #f1f1f1;\r\n}\r\n\r\n/* Position and style the close button (top right corner) */\r\n.sidebar .closebtn {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 25px;\r\n  font-size: 12px;\r\n  margin-left: 50px;\r\n}\r\n\r\n/* The button used to open the sidebar */\r\n.openbtn {\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  background-color: #111;\r\n  color: white;\r\n  padding: 10px 15px;\r\n  border: none;\r\n}\r\n\r\n.openbtn:hover {\r\n  background-color: #444;\r\n}\r\n\r\n/* Style page content - use this if you want to push the page content to the right when you open the side navigation */\r\n#main {\r\n  transition: margin-left .5s; /* If you want a transition effect */\r\n  padding: 20px;\r\n}\r\n\r\n/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */\r\n@media screen and (max-height: 450px) {\r\n  .sidebar {padding-top: 15px;}\r\n  .sidebar a {font-size: 18px;}\r\n}\r\n\r\n/* .centerAlignContents {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n} */\r\n\r\n#root , html ,body{\r\n  height:100%;\r\n}\r\n.center-loading-icon {\r\n    /* Position the top-left corner at the center of the container/viewport */\r\n    position: absolute; /* or fixed, depending on the desired behavior relative to scrolling */\r\n    top: 50%;\r\n    left: 50%;\r\n    \r\n    /* Shift the element back by half of its own dimensions */\r\n    transform: translate(-50%, -50%);\r\n    \r\n}\r\n\r\n\r\n.center-icon{\r\n      display: flex;\r\n    justify-content: center; /* Centers horizontally */\r\n    align-items: center; /* Centers vertically */\r\n    height: 100vh; /* Ensures the container fills the full viewport height */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
